// extracted by mini-css-extract-plugin
export var infoItem = "_ro-2";
export var title = "_ro-0";
export var value = "_ro-1";